export default __webpack_public_path__ + "512603a2448076ac0f6f98d3caa7e947.woff2";